module.exports = __webpack_public_path__ + "img/custom-user.6014e90d.svg";